<template>
  <div>
    <!-- Layout TRIBANCO - Lado a lado (igual FormDocNumber.vue) -->
    <div id="lp1" class="tribanco-landing-container" v-if="isTribanco && !notExists">
      <div class="container">
        <div class="row justify-content-center align-items-stretch no-gutters">
          <div class="col-12 col-md-6 col-lg-5 px-0 mb-0 mb-md-0">
            <div class="tribanco-image-wrapper">
              <img class="img-fluid d-block w-100 tribanco-image" :src="wwwurl + 'img/Banner Portal Tribanco.png'"
                alt="Banner TRIBANCO" />
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 px-0">
            <div class="card bg-white shadow rounded tribanco-form-card h-100">
              <div class="card-body p-3 p-md-4">
                <h4 class="mb-2">Olá, {{ accessname }}<br /></h4>
                <h5 class="text-muted mb-3">Preencha os campos abaixo</h5>
                <h6>
                  CPF / CNPJ
                  <span class="badge badge-light">
                    Digite os 4 primeiros números</span>
                </h6>
                <p class="text-muted text-left small mb-1">
                  Por segurança, digite apenas os 4 primeiros dígitos do seu CPF
                  ou CNPJ:
                </p>
                <form v-on:submit="dologin" v-on:submit.prevent id="form">
                  <div class="input-group mb-3">
                    <input type="text" aria-label="Recipient's username" aria-describedby="basic-addon"
                      class="form-control" required :disabled="loading" :value="form.accessdoc" 
                      @input="handleDocInput" maxlength="4" />
                    <div class="input-group-append d-flex justify-content-start">
                      <span class="input-group-text text-left" id="basic-addon">xx.xxx-xx ou x.xxx/xxxx-xx</span>
                    </div>
                  </div>
                  <div class="form-group mb-3">
                    <p class="text-left small mb-1 text-muted">
                      Digite o código de acesso que recebeu:
                    </p>
                    <input type="text" class="form-control" placeholder="Código de acesso" id="form" label="Digite"
                      v-model="form.accesscode" :disabled="loading" />
                    <div class="col-md-8" style="padding: 0px">
                      <div v-if="promoCodeErrors.length" style="text-align: left; font-size: 11px">
                        <b v-for="error in promoCodeErrors" v-bind:key="error" v-bind:class="classMessage"
                          class="form-text">{{ error }}</b>
                      </div>
                    </div>
                  </div>
                  <p class="small ml-4">
                    Ao acessar você aceita os
                    <a class="text-primary" data-target="#termos-de-uso" data-toggle="modal" href="#">Termos de uso.</a>
                  </p>
                  <button v-if="!loading" type="submit" class="btn mx-auto btn-lg btn-success text-white mt-3">
                    Prosseguir
                  </button>
                </form>
                <div class="mt-3">
                  <ProgressLoading v-bind:loading="loading" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Layout TRICARD - Imagem de fundo com card no meio (igual FormDocNumber.vue) -->
    <div id="lp1-tricard"
      class="d-flex flex-column align-items-center justify-content-center min-vh-100 banner-landing-tricard"
      v-else-if="!notExists">
      <div class="card mx-auto text-center" style="max-width: 400px; width: 100%">

        <form v-on:submit="dologin" v-on:submit.prevent class="px-3">
          <div v-if="notExists" class="mb-3">
            <p class="text-muted text-center small mb-1">
              Código {{ $route.params.mailing }} informado inválido ou
              inexistente
            </p>
          </div>
          <h4 class="px-3">Olá, {{ accessname }}<br /></h4>
          <p class="text-muted text-left small mb-1 px-3">
            Por segurança, digite apenas os 4 primeiros dígitos do seu CPF
            ou CNPJ:
          </p>
          <div class="form-group px-3">
            <div class="input-group mb-3">
              <input type="text" aria-label="Recipient's username" aria-describedby="basic-addon" class="form-control"
                required :disabled="loading" :value="form.accessdoc" @input="handleDocInput" maxlength="4" />
              <div class="input-group-append d-flex justify-content-start">
                <span class="input-group-text text-left" id="basic-addon">xx.xxx-xx ou x.xxx/xxxx-xx</span>
              </div>
            </div>
          </div>
          <div class="form-group mb-3 px-3">
            <p class="text-left small mb-1 text-muted">
              Digite o código de acesso que recebeu:
            </p>
            <input type="text" class="form-control" placeholder="Código de acesso" v-model="form.accesscode"
              :disabled="loading" />
            <div v-if="promoCodeErrors.length" style="text-align: left; font-size: 11px">
              <b v-for="error in promoCodeErrors" v-bind:key="error" v-bind:class="classMessage" class="form-text">{{
                error }}</b>
            </div>
          </div>
          <div class="px-3">
            <p class="small ml-4">
              Ao acessar você aceita os
              <a class="text-primary" data-target="#termos-de-uso" data-toggle="modal" href="#">Termos de uso.</a>
            </p>
            <button v-if="!loading" type="submit" class="btn btn-lg btn-success text-white w-100 mt-3">
              Prosseguir
            </button>
          </div>
          <div class="mt-3 px-3">
            <ProgressLoading v-bind:loading="loading" />
          </div>
        </form>
      </div>
    </div>

    <div class="text-center" v-if="notExists">
      <h2 style="color: #fff;">Link de acesso vencido! Por favor, use um link válido.</h2>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProgressLoading from "../../modules/auth/components/ProgressLoading.vue";
import { ActionGetIPAddress } from "@/utils/helpers";

export default {
  components: {
    ProgressLoading,
  },
  name: "Landing",
  mixins: [validationMixin],
  validations: {
    form: {
      accessdoc: { required, minLength: minLength(4) },
    },
  },
  data: () => ({
    themeBackground: "/img/lp1.jpg",
    imageBackground: null,
    form: {
      accessdoc: null,
      accesscode: null,
    },
    error: {
      alert: false,
      status: null,
      message: null,
    },
    accessname: "",
    loading: false,
    notExists: false,
    initializing: true,
    largura: null,
    termsAcepted: false,
    wwwurl: window.location.href.split("acesso")[0],
    ipUser: null,
    envOwnerId: process.env.VUE_APP_OWNER_ID,
  }),
  computed: {
    isTribanco() {
      const ownerId = this.envOwnerId;
      if (!ownerId) return false;

      if (Array.isArray(ownerId)) {
        return ownerId.map(Number).some((id) => [8, 22].includes(id));
      }

      return [8, 22].includes(Number(ownerId));
    },
    promoCodeErrors() {
      const errors = [];

      if (!this.$v.form.accessdoc.$dirty) return errors;
      !this.$v.form.accessdoc.required && errors.push("Campo é obrigatório!");
      !this.$v.form.accessdoc.minLength &&
        errors.push("O CPF/CNPJ não está completo!");

      return errors;
    },
    classMessage: function () {
      return {
        "text-danger": this.error.status == "ERROR",
        "text-muted": !this.error.status == "ERROR",
      };
    },
  },
  methods: {
    ...mapActions("auth", [
      "ActionGetMailingFirstName",
      "ActionMailingDoLogin",
    ]),
    handleDocInput(event) {
      // Aceita letras e números (para CNPJ alfanumérico conforme IN RFB nº 2.119/2022)
      const value = event.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
      this.form.accessdoc = value.substring(0, 4);
      event.target.value = this.form.accessdoc;
    },
    async dologin() {
      this.promoCodeErrors.pop();
      this.error.status = "ERROR";
      this.$v.$touch();

      if (this.$v.$invalid) {
        // formulário inválido
      } else {
        this.loading = true;
        try {
          await this.ActionMailingDoLogin({
            DocNumber: this.form.accessdoc,
            AccessCode: this.form.accesscode,
            DeviceName: process.env.VUE_APP_API_DEVICE,
            OS: navigator.platform,
            IP: this.ipUser ? this.ipUser : "",
          });
          this.loading = false;
          location.href = "/";
        } catch (error) {
          this.promoCodeErrors.push(
            "ocorreu um erro ao autenticar, dados informados inválido"
          );
          this.error.status = "ERROR";
          this.loading = false;
        }
      }
    },

    async getIPAddressUser() {
      let maxAttempts = 10;
      let attempts = 0;

      while (attempts < maxAttempts) {
        try {
          this.ipUser = await ActionGetIPAddress();
          console.log("this.ipUser: " + JSON.stringify(this.ipUser));
          break; // Saia do loop se o IP for obtido com sucesso
        } catch (error) {
          console.log("Erro ao obter o endereço IP. Tentando novamente...");
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000)); // Aguarde 1 segundo antes de tentar novamente
        }
      }

      if (attempts === maxAttempts) {
        console.log(
          "Número máximo de tentativas atingido. Não foi possível obter o endereço IP."
        );
      }
    },
  },
  async created() {
    this.loading = true;
    await this.getIPAddressUser();
    this.largura = window.screen.width;
    this.form.accesscode = this.$route.params.mailing;
    var result = await this.ActionGetMailingFirstName({
      AccessCode: this.form.accesscode,
      IP: this.ipUser ? this.ipUser : "",
      OS: navigator.platform,
    });
    if (result.data.code !== 200) {
      this.notExists = true;
      this.loading = false;
    } else {
      this.accessname = result.data.results.FirstName;
      this.loading = false;
    }

    this.initializing = false;
  },
};
</script>
<style scoped>
/* Layout TRIBANCO - Lado a lado */
.tribanco-landing-container {
  background-color: #309EDA !important;
  min-height: 100vh;
  padding: 100px 0 20px 0;
  display: flex;
  align-items: center;
}

.tribanco-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: stretch;
  height: 100%;
}

.tribanco-image {
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.tribanco-form-card {
  max-width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.tribanco-form-card .card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Remove espaçamento entre imagem e card no desktop */
.row.no-gutters>[class*='col-'] {
  padding-right: 0;
  padding-left: 0;
}

@media (max-width: 768px) {
  .tribanco-landing-container {
    padding: 20px 0 15px 0;
  }

  .tribanco-image-wrapper {
    height: auto;
  }

  .tribanco-image {
    height: auto;
    object-fit: contain;
  }

  .tribanco-form-card {
    margin-top: 0;
  }
}

@media (max-width: 576px) {
  .tribanco-landing-container {
    padding: 20px 0 10px 0;
  }

  .tribanco-form-card .card-body {
    padding: 15px !important;
  }

  .input-group-text {
    font-size: 0.75rem;
  }
}

/* Layout TRICARD - Imagem de fundo com card no meio */
.banner-landing-tricard {
  background-image: url('/img/banner-outubro-2025.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 20px;
}

@media (max-width: 500px) {
  .banner-landing-tricard {
    background-image: url('/img/banner-outubro-2025-mobile.jpg');
    background-position: top center;
    /* LandingLayout: navbar fixa ~72px */
    padding: calc(72px + env(safe-area-inset-top, 0px) + 6px) 10px 16px;
    justify-content: flex-start;
    box-sizing: border-box;
    min-height: 100dvh;
    min-height: 100vh;
  }
}
</style>